import React from 'react';

import Radio, { RadioProps } from '@material-ui/core/Radio';

export interface SesamRadioProps extends RadioProps {}

const SesamRadio: React.FC<SesamRadioProps> = (props) => <Radio {...props} />;

export default SesamRadio;
